import { CivikukCookieControlService } from "./Civikuk/CivikukCookieControlService";
import { SetCookie, GetCookie, EraseCookie } from "./CookieUtil";
export class CookieControlService {
    constructor() {
        this.cookieControlService = new CivikukCookieControlService();
    }
    Init(options) {
        this.SetupCookieControlOptions(options);
        const onAcceptCallback = this.GetAcceptCallback();
        const onRevokeCallback = this.GetRevokeCallback();
        this.cookieControlService.Load(options, onAcceptCallback, onRevokeCallback);
    }
    Open() {
        this.cookieControlService.Open();
    }
    UpdateConsent(purpose, accept) {
        this.cookieControlService.UpdateConsent(purpose, accept);
    }
    SetupCookieControlOptions(options) {
        options.position = options.position || 'RIGHT';
        options.theme = options.theme || 'DARK';
        options.branding = options.branding || {
            fontColor: "#FFF",
            fontSizeTitle: "1.2em",
            fontSizeIntro: "1em",
            fontSizeHeaders: "1em",
            fontSize: "0.8em",
            backgroundColor: "#313147",
            toggleText: "#fff",
            toggleColor: "#2f2f5f",
            toggleBackground: "#111125",
            buttonIcon: null,
            buttonIconWidth: 64,
            buttonIconHeight: 64,
            removeIcon: true,
            removeAbout: false
        };
        options.initialState = options.initialState || "notify";
        options.notifyDismissButton = options.notifyDismissButton == undefined ? false : options.notifyDismissButton;
        options.necessaryCookies = options.necessaryCookies || [];
        options.necessaryCookies.push("FlowliConsentCookie", "AntiForgery.*", "XSRF-TOKEN", "CorrelationId", "flowliVersion", "referral");
    }
    GetAcceptCallback() {
        return (purpose) => {
            let purposes = GetCookie("FlowliConsentCookie");
            const purposesArray = purposes ? purposes.split(",") : [];
            if (purposesArray.indexOf(purpose) == -1) {
                purposesArray.push(purpose);
            }
            purposes = purposesArray.length == 1 ? purposesArray[0] : purposesArray.join(",");
            SetCookie("FlowliConsentCookie", purposes, 60);
        };
    }
    GetRevokeCallback() {
        return (purpose) => {
            let purposes = GetCookie("FlowliConsentCookie");
            const purposesArray = purposes ? purposes.split(",") : [];
            const purposeIndex = purposesArray.indexOf(purpose);
            if (purposeIndex > -1) {
                purposesArray.splice(purposeIndex, 1);
            }
            if (purposesArray.length > 0) {
                purposes = purposesArray.length == 1 ? purposesArray[0] : purposesArray.join(",");
                SetCookie("FlowliConsentCookie", purposes, 60);
            }
            else {
                EraseCookie("FlowliConsentCookie");
            }
        };
    }
}
//# sourceMappingURL=CookieControlService.js.map